import { render, staticRenderFns } from "./TituloHistoricoEscolar.vue?vue&type=template&id=25b31ffc&"
import script from "./TituloHistoricoEscolar.vue?vue&type=script&lang=js&"
export * from "./TituloHistoricoEscolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports